import {handleResponse, authHeader} from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;
export const LeadService = {
    getLeads,
	resubmit,
	getSources,
	updateSources,
	refreshSources,
	getRegionPricing,
	setRegionPricing,
	setExpenditure,
}

function setExpenditure(model) {
    const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(model)
	};

	return fetch(`${BASE_URL}/leadsources/expenditure`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function setRegionPricing(model) {
    const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(model)
	};

	return fetch(`${BASE_URL}/leadsources/region-pricing`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getRegionPricing() {
    const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(`${BASE_URL}/leadsources/region-pricing`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getSources() {
    const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(`${BASE_URL}/leadsources`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function updateSources(model) {
    const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(model)
	};

	return fetch(`${BASE_URL}/leadsources`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function refreshSources() {
    const requestOptions = {
		method: 'POST',
		headers: authHeader(),
	};

	return fetch(`${BASE_URL}/leadsources/refresh`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getLeads(page) {
    if (!page) {
        page = 1;
    }
    const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(`${BASE_URL}/internal/lead-processing/${page}`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function resubmit(id) {
    if (!id) {
        return Promise.reject(new Error('id required'))
    }
    const requestOptions = {
		method: 'POST',
		headers: authHeader(),
	};

	return fetch(`${BASE_URL}/internal/lead-processing/${id}/resubmit`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}
